import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

interface RemoveBlockDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  blockName: string
  onRemoveFromPage: () => void
  onDeletePermanently: () => void
}

export function RemoveBlockDialog({
  open,
  onOpenChange,
  blockName,
  onRemoveFromPage,
  onDeletePermanently,
}: RemoveBlockDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Remove Content Block</DialogTitle>
          <DialogDescription>
            What would you like to do with <strong>{blockName}</strong>?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-col gap-2 sm:flex-col">
          <Button variant="outline" onClick={onRemoveFromPage}>
            Remove from page
          </Button>
          <Button variant="destructive" onClick={onDeletePermanently}>
            Delete permanently
          </Button>
          <Button variant="ghost" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
